import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '../../lib/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            'inline-flex h-10 items-center justify-start rounded-lg bg-neutral-100 gap-1 text-md font-semibold leading-relaxed p-1',
            className
        )}
        {...props}
    />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'inline-flex items-center justify-center whitespace-nowrap py-1 px-3 text-sm md:text-md focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=inactive]:hover:text-neutral-700 rounded font-semibold transition-all duration-150 data-[state=active]:bg-neutral-50 data-[state=active]:text-primary data-[state=inactive]:bg-transparent data-[state=inactive]:text-neutral-500',
            className
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={cn('mt-4 ml-2 focus-visible:outline-hidden', className)}
        {...props}
    />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
